<template>
  <d-col cols="12" md="3" class="form-group mb-0">
    <label>
      Medida <small>(Área: {{ fieldArea }}m²)</small>
    </label>

    <div class="d-flex w-100 align-items-center justify-content-between">
      <d-col cols class="text-center p-0 pr-2">
        <InputMeasure
          :model="model.service"
          model-index="project_width"
          placeholder="Largura"
          :disabled="disabled"
        />
        <small>Largura</small>
      </d-col>

      <span class="mb-4">x</span>

      <d-col cols class="text-center p-0 pl-2">
        <InputMeasure
          :model="model.service"
          model-index="project_length"
          placeholder="Comprimento"
          :disabled="disabled"
        />
        <small>Comprimento</small>
      </d-col>
    </div>
  </d-col>
</template>

<script>
import InputMeasure from '_shared/InputMeasure.vue';

export default {
  name: 'ProjectMeasure',
  components: { InputMeasure },
  props: {
    model: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    fieldArea() {
      const { project_width: projectWidth, project_length: projectLength } = this.model.service || {};
      if (projectWidth && projectLength) {
        return (projectWidth * projectLength).toLocaleString('pt-BR');
      }
      return 0;
    },
  },
};
</script>
